// extracted by mini-css-extract-plugin
export default {"ErrorFlash":"ChecksGroup-module__ErrorFlash--kQoM4","ErrorOcticon":"ChecksGroup-module__ErrorOcticon--LFfTW"};